import store from '../state/store'
import { getModalComponent } from '../config/modal-registry'
import { getModalContentWithOverrides } from '../config/modal-content'

class ModalService {
    /**
     * Show a modal by content key
     * @param {string} contentKey - The key from MODAL_CONTENT
     * @param {object} overrides - Optional data overrides
     */
    show(contentKey, overrides = {}) {
        const content = getModalContentWithOverrides(contentKey, overrides)
        const component = getModalComponent(content.type)

        if (!component) {
            console.error(`Modal type "${content.type}" not found in registry`)
            return
        }

        store.dispatch('modal/showModal', {
            type: content.type,
            component,
            data: content,
        })
    }

    /**
     * Show a modal with custom data (bypasses content configuration)
     * @param {string} type - The modal type from registry
     * @param {object} data - Complete data for the modal
     */
    showCustom(type, data) {
        const component = getModalComponent(type)

        if (!component) {
            console.error(`Modal type "${type}" not found in registry`)
            return
        }

        store.dispatch('modal/showModal', {
            type,
            component,
            data,
        })
    }

    /**
     * Hide the currently open modal
     */
    hide() {
        store.dispatch('modal/hideModal')
    }

    /**
     * Replace the current modal with a new one
     * @param {string} contentKey - The key from MODAL_CONTENT
     * @param {object} overrides - Optional data overrides
     */
    replace(contentKey, overrides = {}) {
        const content = getModalContentWithOverrides(contentKey, overrides)
        const component = getModalComponent(content.type)

        if (!component) {
            console.error(`Modal type "${content.type}" not found in registry`)
            return
        }

        store.dispatch('modal/replaceModal', {
            type: content.type,
            component,
            data: content,
        })
    }

    /**
     * Update data for the currently open modal
     * @param {object} data - Data to merge with existing modal data
     */
    updateData(data) {
        store.dispatch('modal/updateModalData', data)
    }

    // Legacy methods for backward compatibility (will be removed after migration)
    showModal(type, data = {}) {
        console.warn('modalService.showModal() is deprecated. Use modalService.show() or modalService.showCustom()')
        this.showCustom(type, data)
    }

    hideModal() {
        console.warn('modalService.hideModal() is deprecated. Use modalService.hide()')
        this.hide()
    }

    showAuthPrompt(data = {}) {
        console.warn('modalService.showAuthPrompt() is deprecated. Use modalService.show("AUTH_REQUIRED_FOR_PLAYBACK")')
        this.show('AUTH_REQUIRED_FOR_PLAYBACK', data)
    }

    showPremiumUpsell(data = {}) {
        console.warn('modalService.showPremiumUpsell() is deprecated. Use modalService.show("PREMIUM_UPSELL_GENERAL")')
        this.show('PREMIUM_UPSELL_GENERAL', data)
    }

    showError(data = {}) {
        console.warn('modalService.showError() is deprecated. Use modalService.show("ERROR_GENERIC")')
        this.show('ERROR_GENERIC', data)
    }

    showConfirmation(data = {}) {
        console.warn('modalService.showConfirmation() is deprecated. Use modalService.show("CONFIRM_DELETE")')
        this.show('CONFIRM_DELETE', data)
    }
}

export default new ModalService()
